import { APP_STORE_URL } from "../constants/productLinks";
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import HomeHeroDemo from "../components/HomeHeroDemo";
import InputBar, { type ChatDomain } from "../components/InputBar";
import "../styles/Global.css";
import Footer from "../components/Footer";
import { useAuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import ModernTestimonialsSection from "../components/ModernTestimonialsSection";
import SEO from "../components/SEO";
import { authenticatedFetch } from "../utils/authenticatedFetch";
import { AcademicCapIcon as HeaderQBankIcon } from "@heroicons/react/24/outline";
import appStoreBadge from "../assets/app-store-badge.svg";
import chatSourcesPreview from "../assets/03-chat-sources.png";





// Feature icons as React components
const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.featureIcon}>
    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
  </svg>
);

const BookOpenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.featureIcon}>
    <path d="M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z" />
  </svg>
);

const BoltIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.featureIcon}>
    <path fillRule="evenodd" d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z" clipRule="evenodd" />
  </svg>
);

const AcademicCapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.featureIcon}>
    <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912l-.003.002-.34.18a.75.75 0 01-.707 0A50.009 50.009 0 007.5 12.174v-.224c0-.131.067-.248.172-.311a54.614 54.614 0 014.653-2.52.75.75 0 00-.65-1.352 56.129 56.129 0 00-4.78 2.589 1.858 1.858 0 00-.859 1.228 49.803 49.803 0 00-4.634-1.527.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
    <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
    <path d="M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z" />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.trustBadgeIcon}>
    <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516 11.209 11.209 0 01-7.877-3.08zm3.346 8.269a.75.75 0 00-1.228-.862l-3.236 4.634L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
  </svg>
);

const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.trustBadgeIcon}>
    <path fillRule="evenodd" d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0116.5 15z" clipRule="evenodd" />
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.trustBadgeIcon}>
    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z" clipRule="evenodd" />
  </svg>
);

const QBankIcon = () => (
  <HeaderQBankIcon className={styles.productIconSvg} aria-hidden="true" />
);

// Arrow Right Icon for buttons
const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const Home = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  // ------------------------------------------------------------------
  // Credit handling (mirrors logic in Chat page)
  // ------------------------------------------------------------------
  const [credits, setCredits] = useState<number>(0);
  const [creditsLoaded, setCreditsLoaded] = useState<boolean>(false);

  // Subscription plan state ("premium", "premium_plus", or null)
  const [subscriptionPlan, setSubscriptionPlan] = useState<string | null>(null);

  // QBank question count
  const [qbankCount, setQbankCount] = useState<number>(0);
  const [qbankCountLoaded, setQbankCountLoaded] = useState<boolean>(false);

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";

  // Fetch credits and qbank count on load
  useEffect(() => {
    loadCredits();
    loadSubscription();
    loadQbankCount();
  }, [user]);

  const handleHomepageQuestionSubmit = (
    message: string,
    inputType: "thread" | "question",
    specialty: string,
    domain: ChatDomain,
    currentCredits: number
  ) => {
    // Require login for all interactions
    if (!user) {
      (window as any).showNotification?.(
        <>
          Please log in to use the chat.{" "}
          <a
            href="/login"
            style={{
              textDecoration: "underline",
              fontWeight: 600,
              color: "inherit",
            }}
          >
            Log in now
          </a>
        </>,
        "info"
      );
      navigate("/login", {
        state: {
          from: "/chat",
          newQuestion: message,
          inputType: "thread",
          specialty,
          domain,
        },
      });
      return;
    }

    // If credits are 0, allow sending if the user has an active subscription
    if (currentCredits <= 0) {
      let hasActiveSubscription = !!subscriptionPlan;

      // If subscription status isn't known yet, perform a quick backend check non-blockingly
      if (!hasActiveSubscription && user?.id) {
        (async () => {
          try {
            const apiUrl =
              process.env.REACT_APP_API_URL || "http://localhost:5001";
            const res = await authenticatedFetch(`${apiUrl}/api/subscriptions/${user.id}`);
            if (res.ok) {
              const data = await res.json();
              if (data && data.status === "active") {
                hasActiveSubscription = true;
                setSubscriptionPlan(data.plan || "premium");
              }
            }
          } catch {
            // Network errors should not block legitimate subscribers later
          } finally {
            // If still no active subscription after the check, block and route to pricing
            if (!hasActiveSubscription) {
              (window as any).showNotification?.(
                <>
                  You have no credits remaining.{" "}
                  <a
                    href="/pricing"
                    style={{
                      textDecoration: "underline",
                      fontWeight: 600,
                      color: "inherit",
                    }}
                  >
                    Click here to get unlimited credits!
                  </a>
                </>,
                "error"
              );
              navigate("/pricing");
            } else {
              // Has an active subscription; proceed to chat seamlessly
              navigate("/chat", {
                state: {
                  newQuestion: message,
                  inputType: "thread",
                  specialty,
                  domain,
                },
              });
            }
          }
        })();
        return; // Prevent immediate fall-through; the async check will navigate
      }

      // If we already know there is no active subscription, block immediately
      if (!hasActiveSubscription) {
        (window as any).showNotification?.(
          <>
            You have no credits remaining.{" "}
            <a
              href="/pricing"
              style={{
                textDecoration: "underline",
                fontWeight: 600,
                color: "inherit",
              }}
            >
              Click here to get unlimited credits!
            </a>
          </>,
          "error"
        );
        navigate("/pricing");
        return;
      }
    }

    // 3) Proceed to chat with the question preserved in navigation state
    navigate("/chat", {
      state: {
        newQuestion: message,
        inputType: "thread", // chat mode from home
        specialty,
        domain,
      },
    });
  };

  const loadCredits = async () => {
    if (!user?.id) return; // No user yet – wait for auth state

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";
      const res = await authenticatedFetch(`${apiUrl}/api/credits/${user.id}`);

      if (res.ok) {
        const data = await res.json();
        setCredits(data.credits ?? 0);
      } else {
        console.error("Failed to fetch credits – status:", res.status);
      }
    } catch (err) {
      console.error("Failed to fetch credits", err);
    }

    setCreditsLoaded(true);
  };

  // Fetch subscription plan (mirrors logic in Chat page)
  const loadSubscription = async () => {
    if (!user?.id) return;

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";
      const res = await authenticatedFetch(`${apiUrl}/api/subscriptions/${user.id}`);

      if (res.ok) {
        const data = await res.json();
        if (data && data.status === "active") {
          setSubscriptionPlan(data.plan); // "premium" | "premium_plus"
        } else {
          setSubscriptionPlan(null);
        }
      } else {
        console.error("Failed to fetch subscription – status:", res.status);
      }
    } catch (err) {
      console.error("Failed to fetch subscription", err);
    }
  };

  // Fetch QBank published question count
  const loadQbankCount = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/qbank/stats`);
      if (res.ok) {
        const data = await res.json();
        if (data?.published_count) {
          setQbankCount(data.published_count);
          setQbankCountLoaded(true);
        }
      }
    } catch (err) {
      console.error("Failed to fetch qbank count", err);
    }
  };

  // Feature cards data
  const features = [
    {
      icon: <CheckCircleIcon />,
      title: "Evidence-Based Answers",
      description: "Explore dental and medical explanations backed by textbook references you can check."
    },
    {
      icon: <BoltIcon />,
      title: "Instant Responses",
      description: "No more hours of searching. Get comprehensive answers to your clinical questions in seconds."
    },
    {
      icon: <AcademicCapIcon />,
      title: "Exam Preparation",
      description: "Prepare for SDLE dentistry or SMLE medicine with specialty practice, referenced explanations, and mock exams."
    }
  ];

  return (
    <div className={styles.pageContainer}>
      <SEO
        title="C-Shaped | SDLE & SMLE Study Assistant and Question Banks"
        description="Prepare for SDLE dentistry and SMLE medicine with question banks, timed mock exams, and AI explanations backed by textbook references. Available on web and iOS."
        canonical="https://c-shaped.com/"
        ogTitle="C-Shaped – SDLE & SMLE Exam Preparation"
        ogImage="https://c-shaped.com/logo.png"
        schemaData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "C-Shaped",
          "operatingSystem": "Web, iOS",
          "applicationCategory": "EducationalApplication",
          "description": "Dental and medical AI study assistant with referenced answers, SDLE and SMLE question banks, and mock exams.",
          "sameAs": [APP_STORE_URL],
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "publisher": {
            "@type": "Organization",
            "name": "C-Shaped",
            "url": "https://c-shaped.com",
            "logo": "https://c-shaped.com/logo.png"
          }
        }}
      />
      <Header className={styles.homeHeader} />
      <main className={styles.mainContent}>
        {/* Hero Section */}
        <Hero demo={<HomeHeroDemo />} composer={<InputBar compact initialDomain="medicine" onSend={handleHomepageQuestionSubmit} credits={credits} subscriptionPlan={subscriptionPlan} />} />

        {/* Modern Testimonials Section */}
        <ModernTestimonialsSection className={styles.homeTestimonials} />

        {/* Mobile App Section */}
        <section className={styles.mobileAppSection}>
          <div className={styles.mobileAppInner}>
            <div className={styles.mobileAppContent}>
              <span className={styles.mobileAppBadge}>C-Shaped for iOS</span>
              <h2 className={styles.mobileAppTitle}>Your SDLE & SMLE study desk, now on iPhone.</h2>
              <p className={styles.mobileAppDescription}>
                Move from quick clinical questions to focused exam practice without leaving your phone.
                The iOS app brings C-Shaped chat, QBank, mock exams, and supervisor workflows into a
                quiet native interface built for daily study.
              </p>

              <div className={styles.mobileActionRow}>
                <a
                  className={styles.appStoreLink}
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download C-Shaped on the App Store"
                >
                  <img
                    src={appStoreBadge}
                    alt="Download on the App Store"
                    className={styles.appStoreBadgeImage}
                  />
                </a>
              </div>

              <div className={styles.mobileFeatureList}>
                <div className={styles.mobileFeatureItem}>
                  <span className={styles.mobileFeatureIndex}>01</span>
                  <span className={styles.mobileFeatureText}>
                    <strong>Native AI chat</strong>
                    Explore dental and medical questions with referenced AI explanations, wherever you study.
                  </span>
                </div>
                <div className={styles.mobileFeatureItem}>
                  <span className={styles.mobileFeatureIndex}>02</span>
                  <span className={styles.mobileFeatureText}>
                    <strong>QBank and mock exams</strong>
                    Practice questions, review explanations, flag items, and track readiness from iPhone.
                  </span>
                </div>
                <div className={styles.mobileFeatureItem}>
                  <span className={styles.mobileFeatureIndex}>03</span>
                  <span className={styles.mobileFeatureText}>
                    <strong>Supervisor-ready progress</strong>
                    Keep student progress, invitations, and account access aligned across platforms.
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.mobileVisual}>
              <div className={styles.mobilePreviewFrame}>
                <div className={styles.mobileNotch} />
                <img
                  src={chatSourcesPreview}
                  alt="C-Shaped iOS chat sources screen"
                  className={styles.mobilePreviewImage}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Product Showcase Section */}
        <section className={styles.productShowcase}>
          <div className={styles.productShowcaseHeader}>
            <span className={styles.productBadge}>New Features</span>
            <h2 className={styles.sectionTitle}>Powerful Tools for Your Success</h2>
            <p className={styles.sectionSubtitle}>
              Question banks, referenced explanations, and mock exams for SDLE and SMLE preparation
            </p>
          </div>

          <div className={styles.productGrid}>
            {/* QBank Card */}
            <div className={styles.productCard}>
              <div className={styles.productCardGlow} />
              <div className={styles.productCardContent}>
                <div className={styles.productIconWrapper}>
                  <QBankIcon />
                </div>
                <div className={styles.productInfo}>
                  <div className={styles.productTagRow}>
                    <span className={styles.productTag}>SDLE &amp; SMLE</span>
                    {qbankCountLoaded && <span className={styles.productTagHighlight}>{qbankCount.toLocaleString()} SDLE questions</span>}
                  </div>
                  <h3 className={styles.productTitle}>QBank</h3>
                  <p className={styles.productSubtitle}>
                    AI-Explained Question Bank
                  </p>
                  <p className={styles.productDescription}>
                    Prepare for SDLE dentistry or SMLE medicine with dedicated question banks.
                    Review AI explanations and the textbook references behind each answer.
                  </p>
                  <ul className={styles.productFeatures}>
                    <li>
                      <CheckCircleIcon />
                      <span>Evidence-based explanations for every answer</span>
                    </li>
                    <li>
                      <CheckCircleIcon />
                      <span>Organized by specialty and difficulty</span>
                    </li>
                    <li>
                      <CheckCircleIcon />
                      <span>Track your progress and weak areas</span>
                    </li>
                  </ul>
                  <button
                    className={styles.productButton}
                    onClick={() => document.getElementById('choose-exam')?.scrollIntoView()}
                  >
                    Choose Your Exam
                    <ArrowRightIcon />
                  </button>
                </div>
              </div>
            </div>

            {/* Mock Exams Card */}
            <div className={`${styles.productCard} ${styles.productCardMockExams}`}>
              <div className={styles.productCardGlow} />
              <div className={styles.productCardContent}>
                <div className={styles.productIconWrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={styles.productIconSvg}>
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <div className={styles.productInfo}>
                  <div className={styles.productTagRow}>
                    <span className={styles.productTag}>Premium Plus</span>
                    <span className={styles.productTagSecondary}>50 Questions</span>
                  </div>
                  <h3 className={styles.productTitle}>Mock Exams</h3>
                  <p className={styles.productSubtitle}>
                    Simulate Real Exam Experience
                  </p>
                  <p className={styles.productDescription}>
                    Test your SDLE or SMLE readiness with timed mock exams from your chosen bank.
                    Track your time, review your answers, and see performance by specialty.
                  </p>
                  <ul className={styles.productFeatures}>
                    <li>
                      <CheckCircleIcon />
                      <span>Random 50-question timed sessions</span>
                    </li>
                    <li>
                      <CheckCircleIcon />
                      <span>Score breakdown by specialty</span>
                    </li>
                    <li>
                      <CheckCircleIcon />
                      <span>Full explanations after submission</span>
                    </li>
                  </ul>
                  <button
                    className={styles.productButton}
                    onClick={() => document.getElementById('choose-exam')?.scrollIntoView()}
                  >
                    Choose Your Exam
                    <ArrowRightIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Floating decorative elements */}
          <div className={styles.productShowcaseDecor}>
            <div className={styles.decorCircle1} />
            <div className={styles.decorCircle2} />
            <div className={styles.decorCircle3} />
          </div>
        </section>

        {/* Features Section */}
        <section className={styles.featuresSection}>
          <div className={styles.featuresHeader}>
            <h2 className={styles.sectionTitle}>Built for Dental & Medical Exam Preparation</h2>
            <p className={styles.sectionSubtitle}>
              Practice for SDLE or SMLE with tools that help you understand the reasoning
            </p>
          </div>
          <div className={styles.featuresContent}>
            {features.map((feature, index) => (
              <div key={index} className={styles.featureCard}>
                <div className={styles.featureIconWrapper}>
                  {feature.icon}
                </div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* How It Works Section */}
        <section className={styles.howItWorksSection}>
          <div className={styles.howItWorksHeader}>
            <h2 className={styles.sectionTitle}>See C-Shaped in Action</h2>
            <p className={styles.sectionSubtitle}>
              See how referenced AI explanations support your study sessions
            </p>
          </div>
          <div className={styles.videoOuterContainer}>
            <div className={styles.videoContainer}>
              <iframe
                className={styles.videoIframe}
                src="https://www.youtube.com/embed/Y2WXA7ltIVE?si=s1R5uuk_KRkBT5Ov"
                title="How It Works Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className={styles.ctaSection}>
          <h2 className={styles.ctaTitle}>Ready for Your Next SDLE or SMLE Study Session?</h2>
          <p className={styles.ctaSubtitle}>
            Choose dentistry or medicine and build understanding with each question.
          </p>
          <a href="/signup" className={styles.ctaButton}>
            Get Started Free
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </section>
      </main>
      <Footer tagline="Dental and medical study tools for SDLE & SMLE preparation." />
    </div>
  );
};

export default Home;
